import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import heroImg from "../asssets/event.jpeg";
import heroImg2 from "../asssets/event2.jpg";
import beforeImg from "../asssets/homepage.jpg";
import afterImg from "../asssets/homepage.jpg";
import beforeImg01 from "../asssets/beforeImg01.png";
import afterImg01 from "../asssets/afterImg01.png";
import beforeImg02 from "../asssets/beforeImg02.png";
import afterImg02 from "../asssets/afterImg02.png";
import logo from "../asssets/logom3dpro.png";
import headerunic from '../m3dasset/headerunic.png';
import DropdownMenu from '../components/dropdownmenu';
import Footer from '../components/footerm3d';
import logom3dstudiowhite from '../m3dasset/logom3dstudiowhite.png';


function BeforeAfterCarousel({ beforeImg, afterImg }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const examples = [
    { before: beforeImg01, after: afterImg01 },
    { before: beforeImg02, after: afterImg02 }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % examples.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [examples.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + examples.length) % examples.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % examples.length);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch w-full">
        <div className="relative bg-gray-100 overflow-hidden rounded-lg">
          <img src={examples[currentIndex].before} alt="Antes - placeholder" className="w-full h-80 md:h-[420px] object-cover" />
          <div className="absolute left-4 bottom-4">
            <span className="bg-yellow-400 text-black px-4 py-2 rounded-full font-medium" style={{ fontFamily: "'chillax variable', sans-serif" }}>ANTES</span>
          </div>
        </div>

        <div className="relative bg-gray-100 overflow-hidden rounded-lg">
          <img src={examples[currentIndex].after} alt="Depois - placeholder" className="w-full h-80 md:h-[420px] object-cover" />
          <div className="absolute right-4 bottom-4">
            <span className="bg-yellow-400 text-black px-4 py-2 rounded-full font-medium" style={{ fontFamily: "'chillax variable', sans-serif" }}>DEPOIS</span>
          </div>
        </div>
      </div>

      {/* Dots Navigation */}
      <div className="flex justify-center gap-3 mt-8">
        {examples.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === currentIndex ? 'bg-orange-500 w-8' : 'bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Ir para exemplo ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default function LPEventos3D() {
  return (
    <div className="font-sans text-gray-900 antialiased">
      {/* Header */}{/*max-w-6xl mx-auto px-6 py-4 flex items-center justify-between*/}
      <header className="header ">
         <img src={headerunic} alt="Logo" className="header1red"/>
          <Link to="/">
            <img src={logom3dstudiowhite} alt="Logo" className="logo"/>
          </Link>
          {/* <DropdownMenu className='dropm'/>*/}
      </header>
                
       

      {/* HERO */}
      <section
        className="relative w-full"
        aria-label="Hero"
      >
        <style>{`@media (min-width: 1024px) { .hero-title-desktop { transform: translateX(0); } .hero-content-desktop { transform: translateY(15vh); } }`}</style>
        <img
          src={heroImg}
          alt="Hero background placeholder"
          className="w-full h-[520px] md:h-[640px] object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/30 flex items-center">
          <div className="max-w-6xl mx-auto w-full px-6">
            <div className="max-w-3xl text-left text-white hero-content-desktop">
              <h1 className="font-light leading-tight mb-4 hero-title-desktop">
                <span className="block text-left text-3xl md:text-4xl lg:text-5xl text-white">Renderizações 3D</span>
                <span className="block text-left text-4xl md:text-6xl lg:text-7xl leading-none text-white">Realistas para</span>
                <span className="block text-left text-5xl md:text-7xl lg:text-8xl font-bold leading-none text-white">EVENTOS</span>
              </h1>

              <p className="text-base md:text-lg mb-6 text-orange-100/90">
                Veja e apresente o seu evento antes de ser construído e impressione seus clientes e patrocinadores.
              </p>

              <a
                href="https://api.whatsapp.com/send/?phone=5551982085713&text=Ol%C3%A1%21+Visitei+o+site+de+voc%C3%AAs+e+estou+interessado+em+or%C3%A7ar+um+projeto+3D%21&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                data-event="whatsapp_click"
                data-position="hero"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-400 to-orange-600 hover:from-orange-500 hover:to-orange-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold shadow-2xl transform transition-transform hover:scale-105"
                aria-label="Solicitar Orçamento no WhatsApp"
              >
                <span className="text-sm md:text-base">Solicitar Orçamento no WhatsApp</span>
                <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </a>

              <p className="mt-4 text-sm text-orange-200">Aumente suas vendas com visualizações 3D impressionantes!</p>
            </div>
          </div>
        </div>
      </section>





      {/* Before / After preview (start of page as in print) */}
       <div className="max-w-2xl mx-auto px-6 py-12">
         <h2 className="text-center text-2xl md:text-3xl font-medium mb-10 text-[#444]" style={{ fontFamily: "'chillax variable', sans-serif" }}>
            VEJA COMO PODE SER O SEU EVENTO<br/> ANTES DE SER MONTADO</h2>
       </div>
      <section className="max-w-6xl mx-auto px-6 py-16">
        <BeforeAfterCarousel beforeImg={beforeImg} afterImg={afterImg} />
      </section>

      {/* Small fallback CTA */}
      <section className="text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center">

          <div className="inline-block bg-white rounded-full p-1 shadow-md">
            <a
              href="https://api.whatsapp.com/send/?phone=5551982085713&text=Ol%C3%A1%21+Visitei+o+site+de+voc%C3%AAs+e+estou+interessado+em+or%C3%A7ar+um+projeto+3D%21&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              data-event="whatsapp_click"
              data-position="antes_depois"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-400 to-orange-600 hover:from-orange-500 hover:to-orange-700 text-white px-6 py-3 rounded-full font-semibold shadow-2xl transition-transform hover:scale-105"
              aria-label="Solicitar Orçamento no WhatsApp"
            >
              <span className="text-sm md:text-base">Solicitar Orçamento no WhatsApp</span>
              <span className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                  <path d="M20.52 3.48A11.94 11.94 0 0012 0C5.373 0 .01 5.373.01 12c0 2.11.548 4.09 1.59 5.86L0 24l6.36-1.66A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12 0-3.2-1.25-6.18-3.48-8.52z" fill="#25D366"/>
                  <path d="M17.6 14.2c-.3-.15-1.77-.87-2.04-.97-.27-.1-.46-.15-.66.15s-.76.97-.94 1.17c-.17.2-.35.22-.65.08-.3-.15-1.14-.42-2.17-1.33-.8-.71-1.34-1.58-1.5-1.88-.16-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.19.05-.36-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.58-.48-.5-.66-.51-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.36-.26.29-.99.97-.99 2.37 0 1.39 1.02 2.74 1.16 2.93.15.19 2.01 3.08 4.87 4.31 1.71.72 2.95.92 3.98.74.61-.11 1.77-.72 2.02-1.41.25-.69.25-1.28.17-1.41-.08-.13-.3-.2-.6-.35z" fill="#FFF"/>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </section>

      {/* Benefícios / Por que ter uma visualização 3D */}
      <div className="max-w-2xl mx-auto px-6 py-12">
          <style>{`@media (max-width: 768px) { .mobile-lift { transform: translateY(-3rem); } }`}</style>
          <h2 className="text-center text-2xl md:text-3xl font-medium mb-10 text-[#444] mobile-lift" style={{ fontFamily: "'chillax variable', sans-serif" }}>
            POR QUE TER UMA VISUALIZAÇÃO 3D<br/>É ESSENCIAL PARA EVENTOS?</h2>
        </div>
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div
          className="bg-cover bg-center rounded-2xl p-8 md:p-12"
          style={{ backgroundImage: `url(${heroImg2})` }}
        >
         
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/90 rounded-xl p-6 shadow flex flex-col items-start">
              <div className="w-16 h-16 bg-orange-50 rounded-lg flex items-center justify-center mb-4">
                {/* placeholder icon */}
                <svg className="w-8 h-8 text-orange-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 12h6v8H3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14 7h7v13h-7z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 3h6v18H9z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="font-semibold text-lg mb-2">Venda Antes de Construir<br/>Apresente seu projeto de forma tão realista que o cliente não precise imaginar nada.</h3>
              <p className="text-gray-600">Imagens 3D que transformam plantas e ideias em experiências visuais capazes de acelerar decisões e aumentar o valor percebido do seu projeto.</p>
            </div>

            <div className="bg-white/90 rounded-xl p-6 shadow flex flex-col items-start">
              <div className="w-16 h-16 bg-orange-50 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-orange-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 12h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 17h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="font-semibold text-lg mb-2">Evite Retrabalho e Decisões Incertas<br/>Visualize tudo antes da execução e elimine erros que custam tempo e dinheiro. </h3>
              <p className="text-gray-600">Com um planejamento visual claro, você antecipa problemas, ajusta detalhes e garante mais segurança em cada etapa do projeto.</p>
            </div>

            <div className="bg-white/90 rounded-xl p-6 shadow flex flex-col items-start">
              <div className="w-16 h-16 bg-orange-50 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-orange-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7l3-7z" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="font-semibold text-lg mb-2">Impressione e Gere Desejo<br/>Crie apresentações que encantam clientes, investidores e patrocinadores.</h3>
              <p className="text-gray-600">Mais do que imagens bonitas, entregamos materiais que destacam o potencial do projeto e fazem as pessoas quererem fazer parte dele.s.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Por que escolher a M3D + Como funciona (cards em faixa) 
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div
          className="bg-cover bg-center rounded-2xl p-8 md:p-12"
          style={{ backgroundImage: `url(${heroImg})` }}
        >
          <h3 className="text-center text-lg md:text-2xl font-semibold text-white mb-6" style={{ fontFamily: "'chillax variable', sans-serif" }}>POR QUE ESCOLHER A M3D?</h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white/90 rounded-xl p-6 shadow flex flex-col">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 rounded-lg bg-orange-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-orange-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7h16M4 12h10M4 17h7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="font-bold">Vendas — Atrai Mais Patrocinadores</h4>
              </div>
              <p className="text-sm text-gray-700">Nos mande sua ideia e seus materiais, medidas, referências, etc. pelo WhatsApp.</p>
            </div>

            <div className="bg-white/90 rounded-xl p-6 shadow flex flex-col">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 rounded-lg bg-orange-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-orange-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8h18M8 16h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="font-bold">Fazemos o orçamento</h4>
              </div>
              <p className="text-sm text-gray-700">Analisamos as informações e enviamos uma proposta sem compromisso.</p>
            </div>

            <div className="bg-white/90 rounded-xl p-6 shadow flex flex-col">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 rounded-lg bg-orange-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-orange-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2v6M6 8h12M4 20h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="font-bold">Contrato e pagamento inicial</h4>
              </div>
              <p className="text-sm text-gray-700">Ao aprovar, assinamos o contrato e recebemos o pagamento de entrada.</p>
            </div>
          </div>

           Como funciona - segunda faixa 
          <div className="bg-white/80 rounded-xl p-6 md:p-8">
            <h4 className="text-center font-bold text-lg mb-6" style={{ fontFamily: "'chillax variable', sans-serif" }}>COMO FUNCIONA</h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold">1</div>
                <div>
                  <h5 className="font-semibold">Você envia seu projeto ou ideia</h5>
                  <p className="text-sm text-gray-700">Nos mande sua ideia e seus materiais, medidas, referências, etc. pelo WhatsApp.</p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-bold">2</div>
                <div>
                  <h5 className="font-semibold">Fazemos o orçamento</h5>
                  <p className="text-sm text-gray-700">Analisamos as informações e enviamos uma proposta sem compromisso.</p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">3</div>
                <div>
                  <h5 className="font-semibold">Contrato e pagamento inicial</h5>
                  <p className="text-sm text-gray-700">Ao aprovar o orçamento, assinamos o contrato e recebemos o pagamento de entrada.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
*/}
      {/* Extra CTA before footer (same as small fallback, with larger spacing) */}
      <section className="text-white py-20">
        <div className="max-w-6xl mx-auto px-6 text-center">

          <div className="inline-block bg-white rounded-full p-1 shadow-md">
            <a
              href="https://api.whatsapp.com/send/?phone=5551982085713&text=Ol%C3%A1%21+Visitei+o+site+de+voc%C3%AAs+e+estou+interessado+em+or%C3%A7ar+um+projeto+3D%21&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              data-event="whatsapp_click"
              data-position="beneficios"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-400 to-orange-600 hover:from-orange-500 hover:to-orange-700 text-white px-6 py-3 rounded-full font-semibold shadow-2xl transition-transform hover:scale-105"
              aria-label="Solicitar Orçamento no WhatsApp"
            >
              <span className="text-sm md:text-base">Solicitar Orçamento no WhatsApp</span>
              <span className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                  <path d="M20.52 3.48A11.94 11.94 0 0012 0C5.373 0 .01 5.373.01 12c0 2.11.548 4.09 1.59 5.86L0 24l6.36-1.66A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12 0-3.2-1.25-6.18-3.48-8.52z" fill="#25D366"/>
                  <path d="M17.6 14.2c-.3-.15-1.77-.87-2.04-.97-.27-.1-.46-.15-.66.15s-.76.97-.94 1.17c-.17.2-.35.22-.65.08-.3-.15-1.14-.42-2.17-1.33-.8-.71-1.34-1.58-1.5-1.88-.16-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.19.05-.36-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.58-.48-.5-.66-.51-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.36-.26.29-.99.97-.99 2.37 0 1.39 1.02 2.74 1.16 2.93.15.19 2.01 3.08 4.87 4.31 1.71.72 2.95.92 3.98.74.61-.11 1.77-.72 2.02-1.41.25-.69.25-1.28.17-1.41-.08-.13-.3-.2-.6-.35z" fill="#FFF"/>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </section>

    <Footer />

    </div>
  );
}
